import script from "./BUG_WATERMARK_EXCEEDED.vue?vue&type=script&lang=ts&setup=true"
export * from "./BUG_WATERMARK_EXCEEDED.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__